export default String.raw`
{% assign tab = 'offers' -%}
{% assign pageQueryName = customer-profile.Offers.PageQueryGET -%}

{% include 'partials/common/date-format.html' -%}
{% assign offer = customer-profile.Offer -%}
{% assign offerString = customer-profile.OfferQueryGET -%}
{% assign queries = page.QueryString | Split: '&' -%}
{% for query in queries -%}
	{% if query contains 'page=' -%}
		{% assign pageQueryNo = query | Split: '=' | Last -%}
		{% break -%}
	{% else -%}
		{% assign pageQueryNo = 1 -%}
	{% endif -%}
{% endfor -%}

<div class="customer-submenu">
    <div class="customer-submenu__header submenu-header">
        <div class="navigation-header">
            {% if page.QueryString contains 'from-cart=true' -%}
                <a aria-label="{{translations.Back}}" class="pure-button" href="{{ page.BaseHref }}{{config.DefinedPages.Order.Url}}">
            {% else -%}
                <button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/offers/offers.html" data-url="{{ page.Url }}?tab={{tab}}">
            {% endif -%}
                    <svg aria-hidden="true" width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                    </svg>
            {% if page.QueryString contains 'from-cart=true' -%}
                </a>
            {% else -%}
                </button>
            {% endif -%}

            {{ translations.Offer }} {{ offer.Id }}

            {% if offer.Status == 3 and offer.OneTimeOffer == false -%}
                {% assign canProduceMultipleTimes = true -%}
            {% endif -%}
            {% if offer.Status == 2 or canProduceMultipleTimes -%}
                {% assign goodStatus = true -%}
            {% endif -%}
        </div>
        <div class="options">
        {% if page.QueryString contains 'tab=offer-details' and goodStatus -%}
            <button class="primary-action-button produce-offer-js" data-id="{{offer.Id}}" data-redirect-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}" data-message="{{translations.OfferIntoCartInfo}}" data-title="{{translations.OfferExistsInCart}}" data-info="{{translations.OfferExistsInCartInfo}}" data-go-to-cart="{{translations.GoToCart}}" data-change-cart="{{translations.ChangeCart}}">
                {{ translations.ProduceOffer }}
            </button>
        {% endif -%}

                {% if offer.Status == 3 and offer.OneTimeOffer -%}
                    <button class="primary-action button copy-to-cart-js" data-id="{{order.Id}}" data-hash="{{ order.Hash }}" data-redirect-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}">
                        {{ translations.CopyToCart }}
                    </button>
                {% endif -%}
                </div>
			</div>

    <div class="details-info">
        <div class="details">
                <div class="customer-info__content">
                    <div class="title">{{ translations.OfferStatus }}</div>
                    <span>{{ offer.StatusText | Capitalize }}</span>
                </div>
                <div class="customer-info__content">
                    <div class="title">{{ translations.BuyDate }}</div>
                    <span>{{ offer.Date | Date:dateFormat }}</span>
                </div>
        </div>
        <div class="details-info__summary">
            {% include 'partials/common/order-summary.html' with 'offer' -%}
            <div class="summary">
                <div class="title">
                    {{ translations.TotalProductsInCart }} {{ translations.Brutto | Downcase }}
                </div>
                <span>
                    {% if offer.DeliveryTotalValue > 0 -%}
                        {{offer.TotalValue | Plus: offer.DeliveryTotalValue | ToPrice}}
                    {% else -%}
                        {{offer.TotalValue | ToPrice}}
                    {% endif -%}
                    {{ offer.CurrencyExt }}
                </span>
            </div>
        </div>
    </div>

    <div class="info-container-js expandable-mechanism-container-js">
        <button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
            {{ translations.ShowDetails }} 
            <svg height="16" width="16" class="icon rotate-down dropdown-arrow">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
            </svg>
        </button>
        <div class="order-details expandable-js">
            <div class="order-details__row">
                {% assign relatedOffersSize = offer.RelatedOffers | Size -%}
                {% assign relatedOrdersSize = offer.RelatedOrders | Size -%}
                <div class="order-details-item">
                    <div class="title">{{ translations.ExpirationDate }}</div>
                    <span>{{ offer.ExpirationDate | Date:dateFormat }}</span>
                </div>
                {% if relatedOffersSize > 0 -%}
                <div class="order-details-item">
                    <div class="title">{{ translations.Inquiry }}</div>
                    {% for relatedOffer in offer.RelatedOffers -%}
                        <span>
                            {{ relatedOffer.Id }}
                        </span>
                        <button class="set-focus-trap-js parent-container-reload-js" data-template="partials/customer-profile/inquiries/inquiry-details.html" data-url="{{ page.Url }}?{{offerString}}={{ relatedOffer.Id }}&tab=inquiry-details">
                            {{ translations.SeeOfferDetails }}
                        </button>
                        {% if forloop.index != relatedOffersSize -%}, {% endif -%}
                    {% endfor -%}
                </div>
                {% endif -%}
                {% if relatedOrdersSize > 0 -%}
                <div class="order-details-item">
                    <div class="title">{{ translations.Order }}</div>
                    {% for relatedOrder in offer.RelatedOrders -%}
                        <span>
                            {{ relatedOrder.Id }}
                        </span>
                        <button class="pure-button replace-template-js parent-container-reload-js" data-template="partials/customer-profile/orders/order-details.html" data-url="{{ page.Url }}?{{customer-profile.OrderQueryGET}}={{ relatedOrder.Id }}&tab=order-details">
                            {{ translations.SeeOrderDetails }}
                        </button>
                        {% if forloop.index != relatedOrdersSize -%}, {% endif -%}
                    {% endfor -%}
                </div>
                {% endif -%}
            </div>
            <div class="order-details__row">
                <div class="order-details-item">
                    <div class="title">{{ translations.OneTimeOffer }}</div>
                    <span>
                        {% if offer.OneTimeOffer -%}
                            {{ translations.Yes | Upcase }}
                        {% else -%}
                            {{ translations.No | Upcase }}
                        {% endif -%}
                    </span>
                </div>
                {% if offer.SelectedPayment != null -%}
                <div class="order-details-item">
                    <div class="title">{{ translations.PaymentMethod }}</div>
                    <span>{{ offer.SelectedPayment }}</span>
                </div>
                {% endif -%}
                {% if offer.SelectedDelivery != null -%}
                <div class="order-details-item">
                    <div class="title">{{ translations.DelivMethod }}</div>
                    <span>{{ offer.SelectedDelivery }}</span>
                </div>
                {% endif -%}
            </div>
        </div>
    </div>

    <div class="order-products-list-js">
        {% include 'partials/order/products-partials/products.html' -%}
    </div>

    {% if offer.Answer != "" -%}
    <div class="related-erp">
        <div class="order-details-item">
            <div class="title">{{ translations.MessageForCustomer }}</div>
            <span>{{ offer.Answer }}</span>
        </div>    
    </div>
    {% endif -%}

    {% assign attachmentsSize = offer.Attachments | Size -%}
    {% if config.Orders.AttachmentsEnabled and attachmentsSize > 0 -%}
    <div class="attachements-container">
        <div class="title">{{ translations.Attachements }}</div>
        <div class="attachements">
            {% for file in offer.Attachments -%}
                {% assign type = file.Name | Split: '.' | Last | Downcase -%}
                {% if type == "jfif" or type == "jpe" or type == "jpeg" or type == "jpg" -%}
                    {% assign icon = 'file-image' -%}
                {% elseif type == "csv" -%}
                    {% assign icon = 'file-csv' -%}
                {% elseif type == "docx" or type == "odt" or type == "doc" -%}
                    {% assign icon = 'file-word' -%}
                {% elseif type == "xlsx" or type == "ods" or type == "xls" -%}
                    {% assign icon = 'file-spreadsheet' -%}
                {% elseif type == "zip" or type == "rar" or type == "7zip" -%}
                    {% assign icon = 'file-archive' -%}
                {% elseif type == "pdf" -%}
                    {% assign icon = 'file-pdf' -%}
                {% elseif type == "txt" -%}
                    {% assign icon = 'file-alt' -%}
                {% else -%}
                    {% assign icon = 'file' -%}
                {% endif -%}
                <div class="file-container file-container-js">
                    {% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
                    <a href="{{ fileHref }}">				
                        <svg height="24" width="24" class="svgIcon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{icon}}-{{settings.iconStyle}}"></use>
                        </svg> 
                        <span>{{ file.Name }}</span>
                    </a>
                </div>
            {% endfor -%}
        </div>
    </div>
    {% endif -%}
</div>
`